/*LIBRARY*/
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import TEXT_AREA_CHAT from "./TEXT_AREA_CHAT";
import MARKDOWN_RENDERER from "./MARKDOWN_RENDERER";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import {
  get_ai_parent_list,
  set_value_sini,
  get_ai_child_list,
  get_ai_parent_object,
  delete_ai_item,
  fly_init_update,
} from "../../App/actions/sini_v2";
import { post_ai_chat } from "../../App/actions/post_ai_chat";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SINI_AI_PAGE = ({
  auth,
  sini,
  loading_reducer,
  layer,
  get_ai_parent_list,
  set_value_sini,
  get_ai_child_list,
  get_ai_parent_object,
  delete_ai_item,
  fly_init_update,
}) => {
  const [request_id_state, set_request_id_state] = useState("");
  const [autogenerate_title_state, set_autogenerate_title_state] = useState("");
  const [anchor, set_anchor] = useState(null);
  const [modal_menu, set_modal_menu] = useState(false);
  const [modal_delete, set_modal_delete] = useState(false);

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    get_ai_parent_list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const on_scroll_down = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop =
        scrollContainerRef.current.scrollHeight;
    }
  };

  const on_delete_ai_item = () => {
    set_modal_delete(false);

    const query = {
      request_id: request_id_state,
    };
    delete_ai_item(query);

    //delete marker from map
    const marker_id = `marker_center_${request_id_state}`;
    const marker_element = document.getElementById(marker_id);
    if (marker_element) {
      marker_element.remove();
    }

    //delete layer from map
    const { map_object } = layer;
    const layer_id_fill_isochrone = `geojson_polygon_${request_id_state}`;
    const layer_id_line_isochrone = `geojson_polygon_line_${request_id_state}`;
    const layer_id_poi = `poi_${request_id_state}`;
    const layer_id_demography = `geojson_demography_list_${request_id_state}`;
    const layer_id_demography_line = `geojson_demography_list_line_${request_id_state}`;

    if (map_object.getLayer(layer_id_fill_isochrone)) {
      map_object.removeLayer(layer_id_fill_isochrone);
    }
    if (map_object.getLayer(layer_id_line_isochrone)) {
      map_object.removeLayer(layer_id_line_isochrone);
    }
    if (map_object.getLayer(layer_id_poi)) {
      map_object.removeLayer(layer_id_poi);
    }
    if (map_object.getLayer(layer_id_demography)) {
      map_object.removeLayer(layer_id_demography);
    }
    if (map_object.getLayer(layer_id_demography_line)) {
      map_object.removeLayer(layer_id_demography_line);
    }
  };

  const toggle_delete = () => {
    set_modal_menu(false);
    set_modal_delete((prev) => !prev);
  };

  const toggle_menu = (event, request_id, autogenerate_title) => {
    set_modal_menu((prev) => {
      const new_value = !prev;
      if (new_value) {
        set_request_id_state(request_id);
        set_autogenerate_title_state(autogenerate_title);
      }
      return new_value;
    });
    if (event) {
      set_anchor(event?.currentTarget);
    }
  };

  const toggle_ai_page = () => {
    set_value_sini({
      key: "modal_ai_page",
      value: !sini.modal_ai_page,
    });
  };

  const on_click_item = (request_id) => {
    set_value_sini({
      key: "request_id_active",
      value: request_id,
    });
    const { ai_parent_child_list, ai_parent_detail_list } = sini;
    const ai_child_list =
      ai_parent_child_list.find((item) => item?.request_id === request_id)
        ?.ai_child_list || [];
    const sini_db_object_test = ai_parent_detail_list.find(
      (item) => item.request_id === request_id
    )?.request_id;
    const params = {
      request_id: request_id,
    };
    if (ai_child_list.length === 0) {
      get_ai_child_list(params);
    }
    if (!sini_db_object_test) {
      get_ai_parent_object(params);
    } else {
      fly_init_update();
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;
  const isMobile = window.innerWidth <= 650;

  //global props
  const { ai_parent_list, request_id_active, ai_parent_child_list } = sini;
  const { loading_item_array } = loading_reducer;

  //content
  let content;
  if (isMobile) {
    content = (
      <main>
        <p className="text_bold">
          {
            dict?.[
              "For the time being this page is only optimized for large devices (PC & tablet)"
            ]?.[language]
          }
        </p>
        <br />
        <br />
        <button
          className="button_big margin_bottom background_black"
          onClick={toggle_ai_page}
        >
          {dict?.["Back to map"]?.[language]}
        </button>
      </main>
    );
  } else {
    const ai_child_list =
      ai_parent_child_list.find(
        (item) => item?.request_id === request_id_active
      )?.ai_child_list || [];

    const modal_menu_content = (
      <FLOAT_MENU
        id="basic-menu"
        anchorEl={anchor}
        open={modal_menu}
        onClose={toggle_menu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <main>
          <button
            className="button_big button_transparent"
            onClick={toggle_delete}
          >
            {dict?.["Delete"]?.[language]}
          </button>
        </main>
      </FLOAT_MENU>
    );

    const modal_delete_content = modal_delete && (
      <Modal modalSize="small" isOpen={modal_delete} onClose={toggle_delete}>
        <div className="box-body" id="box-body">
          <p className="text_large margin_bottom">
            {dict?.["Delete this conversation?"]?.[language]}
          </p>
          <hr />
          <p className="text_medium margin_bottom">
            {dict?.["This action will delete"]?.[language]}{" "}
            <b>{autogenerate_title_state}</b>
          </p>
          <br />
          <br />
          <button
            className="button margin_right background_grey"
            onClick={toggle_delete}
          >
            {dict?.["Cancel"]?.[language]}
          </button>
          <button className="button background_red" onClick={on_delete_ai_item}>
            {dict?.["Delete"]?.[language]}
          </button>
        </div>
      </Modal>
    );

    let history_content = (
      <div className="text_small container_light outline_black background_grey_light margin_bottom">
        Belum ada SINI AI chat history
      </div>
    );

    if (ai_parent_list.length > 0) {
      history_content = (
        <>
          {ai_parent_list.map((item, idx) => {
            const { request_id, autogenerate_title, title_1, title_2 } = item;
            let title = autogenerate_title
              ? autogenerate_title
              : title_1 + ", " + title_2;
            return (
              <section
                key={idx}
                className={`button_flex button_big full_width text_left margin_bottom ${
                  request_id === request_id_active
                    ? "background_grey outline_black"
                    : "background_grey_light outline_white"
                }`}
                title={autogenerate_title}
              >
                <div
                  className="item_left full_width max_one_lines"
                  onClick={() => on_click_item(request_id)}
                >
                  {title}
                </div>
                <div
                  onClick={(e) => {
                    toggle_menu(e, request_id, title);
                  }}
                  id={request_id}
                  className={`noselect item_right ${
                    request_id === request_id_active ? "show" : ""
                  }`}
                >
                  ...
                </div>
              </section>
            );
          })}
        </>
      );
    }

    content = (
      <main className="ai_page_container">
        {modal_delete_content}
        {modal_menu_content}
        <section className="ai_page_left_sidebar">
          <section
            style={{
              position: "sticky",
              top: "-50px",
              width: "calc( 100% + 20px )",
              backgroundColor: "transparent",
              zIndex: 2,
              paddingTop: "50px",
              paddingBottom: "10px",
            }}
          >
            <button
              className="button_big margin_bottom background_black"
              onClick={toggle_ai_page}
              data-mapid="clickBack"
            >
              Back to map
            </button>
          </section>
          <br />
          {history_content}
        </section>

        <section className="ai_page_chat_list">
          {request_id_active ? (
            <>
              <section
                id="scroll_area"
                style={{
                  overflowY: "auto",
                  height: "calc(100vh - 190px)",
                  paddingRight: "10px",
                }}
                ref={scrollContainerRef}
              >
                <div className="container margin_bottom background_black text_medium">
                  {
                    dict?.["Explore your business ideas with SINI AI!"]?.[
                      language
                    ]
                  }
                  <br />
                  <br />
                  {
                    dict?.[
                      "Find a variety of important information to support business decisions."
                    ]?.[language]
                  }
                  <br />
                  <br />
                  <ol>
                    <li>
                      {
                        dict?.[
                          "Land prices in the location you are targeting"
                        ]?.[language]
                      }
                    </li>
                    <li>
                      {
                        dict?.["Potential location for business development"]?.[
                          language
                        ]
                      }
                    </li>
                    <li>
                      {
                        dict?.[
                          "Characteristics of the area and surrounding environment spatially"
                        ]?.[language]
                      }
                    </li>
                    <li>
                      {
                        dict?.[
                          "Property insights around your chosen location"
                        ]?.[language]
                      }
                    </li>
                    <li>
                      {
                        dict?.[
                          "Disaster risk information at the destination location"
                        ]?.[language]
                      }
                    </li>
                  </ol>
                </div>

                {ai_child_list.map((item, idx) => {
                  let final_content;
                  if (item.role === "assistant" && item.content) {
                    final_content = (
                      <section key={idx} id={`ai_sini_${idx}`}>
                        <div className="container margin_bottom background_black text_medium">
                          <MARKDOWN_RENDERER markdownContent={item.content} />
                        </div>
                      </section>
                    );
                  } else {
                    final_content = (
                      <section key={idx} id={`ai_sini_${idx}`}>
                        <div
                          className="container margin_bottom max_width_300 background_grey_light text_medium"
                          style={{ right: 0, whiteSpace: "pre-wrap" }}
                        >
                          {item.content}
                        </div>
                      </section>
                    );
                  }

                  return final_content;
                })}

                {loading_item_array.includes("post_ai_chat") && (
                  <main>
                    <div className="sini_container_animation">
                      <div className="sini_shape_animation sini_circle_1"></div>
                      <div className="sini_shape_animation sini_circle_2"></div>
                      <div className="sini_shape_animation sini_circle_3"></div>
                    </div>

                    <br />
                    <div
                      className={`container_light outline_transparent margin_bottom background_grey`}
                    >
                      {dict?.["SINI AI is answering"]?.[language]}...
                    </div>
                  </main>
                )}
                <div style={{ height: "200px" }}></div>
              </section>

              <section
                style={{
                  position: "absolute",
                  bottom: "0px",
                  left: 0,
                  right: 0,
                  paddingBottom: "10px",
                  paddingTop: "6px",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                  boxSizing: "border-box",
                  maxWidth: "100%",
                  transform: "translateZ(0)",
                }}
                className="background_grey_light"
              >
                <TEXT_AREA_CHAT
                  scrollContainerRef={scrollContainerRef}
                  on_scroll_down={on_scroll_down}
                />
              </section>
            </>
          ) : (
            <>
              <div className="container margin_bottom background_black text_medium">
                {
                  dict?.["Select one history SINI location analysis first"]?.[
                    language
                  ]
                }
              </div>
            </>
          )}
        </section>
      </main>
    );
  }

  return <>{content}</>;
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  sini: state.sini,
  loading_reducer: state.loading_reducer,
  layer: state.layer,
});

export default connect(mapStateToProps, {
  get_ai_parent_list,
  set_value_sini,
  get_ai_child_list,
  get_ai_parent_object,
  delete_ai_item,
  post_ai_chat,
  fly_init_update,
})(SINI_AI_PAGE);
